import { render, staticRenderFns } from "./WagonDrawAndBufferingGear.vue?vue&type=template&id=49a35620&scoped=true"
import script from "./WagonDrawAndBufferingGear.vue?vue&type=script&lang=js"
export * from "./WagonDrawAndBufferingGear.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a35620",
  null
  
)

export default component.exports